import { CMBox, CMBoxcontainer, CMOffer } from "./transaction-success.styles";
import Button, { BUTTON_TYPE_CLASSES } from "../../button/button.component";

const TransactionSuccess = ({ handleNext, information }) => {
  return (
    <>
      <CMBoxcontainer>
        <CMBox>
          <h3>{information}</h3>
        </CMBox>
      </CMBoxcontainer>

      <CMOffer>
        <Button onClick={handleNext} color="blue">
          Close
        </Button>
      </CMOffer>
    </>
  );
};
export default TransactionSuccess;
